import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, ButtonProps } from 'semantic-ui-react';
import { AppState } from 'services/types';
// @ts-ignore
import { submittingSelectors } from 'shared';

interface OwnProps extends ButtonProps {
    children?: React.ReactElement | string;
    disabled?: boolean;
}

interface ConnectedProps {
    submitting: boolean;
}

type Props = OwnProps & ConnectedProps;

export class SubmittingButtonComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { children, submitting, disabled = false, ...props } = this.props;

        if (!children) return null;

        return (
            <Button
                {...props}
                loading={submitting}
                disabled={submitting || disabled}
            >
                {children}
            </Button>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    submitting: submittingSelectors.makeSelectSubmitting()
});

export default connect(mapStateToProps)(SubmittingButtonComponent);
